module.exports = __webpack_public_path__ + "img/adv2.0658fde0.jpg";